<template>
    <div class="new-panarea">
      <div class="pan-area"></div>
      <AppHeaderBreadcrumb
        v-if="!isSalesOrLandView"
        :areaUrl="headerData.area_url"
        :communityUrl="headerData.community_url"
        :communityName="headerData.community_name"
        :communityEnabled="headerData.community_enabled"
        :neighborhoods="headerData.sibling"
        :selectedNeighborhoodIds="selectedNeighborhoodIds"
        :isKioskMode="isKioskMode"
      />

      <AppHeaderCommunityDetails
        ref="platmapCommunityDetails"
        :headerData="headerData"
        :areaName="areaName"
        :communityName="communityName"
        :availableSites="availableSites"
        :availableLots="availableLots"
        :availablePlans="availablePlans"
        :qmiAndHomeplans="qmiAndHomeplans"
        :qmiAppliedMobile="qmiAppliedMobile"
        :neighborhoodsPlanQmiCount="neighborhoodsPlanQmiCount"
        :selectedNeighborhoodIds="selectedNeighborhoodIds"
        :qmiDetails="qmiDetails"
        :communityHomePlans="communityHomePlans"
        :qmiFilter="qmiFilter"
        :filterQmiCount="filterQmiCount"
        :soldPercentage="soldPercentage"
        :initialHomePlanCount="initialHomePlanCount"
        :homeTypeCount="homeTypeCount"
        :planPriceExsist="planPriceExsist"
        :neighborhoodLotsCount="neighborhoodLotsCount"
        :isComingSoon="isComingSoon"
        @selectNeighborhood="selectNeighborhood"
        @filterPlanNameHomeType="filterPlanNameHomeType"
        @setPlanNameListId="setPlanNameListId"
        @loadNeighborhood="loadNeighborhood"
        @setPlanDetailsHometypeList="setPlanDetailsHometypeList"
        @setSorting="setSorting"
        @applyUrlQmi="applyUrlQmi"
        @applyMobileFilters="applyMobileFilters"
        @applyMobilePriceFilter="applyMobilePriceFilter"
      />
    </div>
    <div class="sidebar-topcontent">
      <div>
        <LotSummary
          v-if="
            Object.keys(lotInformationData).length && showSelectedLotInformation
          "
          :lotInformationData="lotInformationData"
        />
      </div>

      <NeighborhoodList
        v-if="headerData.community_name"
        :siblings="headerData.sibling"
        :soldPercentage="soldPercentage"
        :neighborhoods="neighborhoods"
        :neighborhoodsPlanQmiCount="neighborhoodsPlanQmiCount"
        :selectedNeighborhoodIds="selectedNeighborhoodIds"
        :qmiFilter="qmiFilter"
        :isAnyFilterApplied="isAnyFilterApplied"
        :totalMobileFilterApplied="totalMobileFilterApplied"
        :coordinates="coordinates"
        :neighborhoodLotsCount="neighborhoodLotsCount"
        :isComingSoon="isComingSoon"
        @selectNeighborhood="selectNeighborhood"
        @loadNeighborhood="loadNeighborhood"
        @clearSelectedNeighborhoods="clearSelectedNeighborhoods"
        @hideSibling="hideSibling"
        @highlightNeighborhood="highlightNeighborhood"
        @sethoverNeighborZoomLevel="sethoverNeighborZoomLevel"
      />

      <div :class="['fw-ic-jb mb-20', { hide: hideSortQmiOption }]">
        <div class="sort-price-container">
          <span>Sort :</span>
          <div class="relative" @click="toggleDropdownVisibility">
            <button
              :class="['sort-price-btn', { disableSort: disableSortQmiFilter }]"
            >
              <span>{{ selectedSorting }}</span>
              <ArrowDownIcon :class="{ 'rotate-180': sortDropdown }" />
            </button>
            <div :class="['dropdown', { show: sortDropdown }]">
              <ul>
                <li
                  v-for="(option, idx) in homePlanSortOptions"
                  :key="idx"
                  :class="[
                    'dropdown-item',
                    { 'is-selected': option.value === selectedSorting },
                  ]"
                  @click="setSorting(option)"
                >
                  {{ option.value }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          :class="[
            'qmi-filter form-check',
            { disableSort: disableSortQmiFilter },
          ]"
          v-if="!hasMobile"
        >
          <input
            type="checkbox"
            v-model="qmiFilter"
            class="form-check-input"
            id="qmi"
            @click="qmiFilterUpdate"
          />
          <label for="qmi" class="form-check-label"></label>
          <button class="sort-price-btn" @click="closeQmiFilter">
            <span>Quick Move-in</span>
            <ArrowDownIcon :class="{ 'rotate-180': qmiDaysFilterDropdown }" />
          </button>
          <div :class="['dropdown mr-auto', { show: qmiDaysFilterDropdown }]">
            <ul>
              <li
                class="dropdown-item"
                v-for="(option, idx) in qmiDaysFilter"
                :key="idx"
              >
                <div class="form-check">
                  <input
                    type="checkbox"
                    :id="option.value"
                    :value="option"
                    class="form-check-input"
                    v-model="qmiFilterList"
                  />
                  <label :for="option.value" class="form-check-label">{{
                    option.value
                  }}</label>
                </div>
              </li>
            </ul>
            <div aria-label="cta buttons" class="cta__btn">
              <button class="cta__btntext" @click="clearMoveInDaysFilter">
                Clear
              </button>
              <button
                :class="[
                  'cta__btnsolid',
                  { disableApplyButton: !qmiFilterList.length },
                ]"
                @click="applyMoveInDaysFilter"
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>

      <!--
      <h6 class="desc">
        <span class="green-circle"></span>
        {{ messages.sidebarMessage }}
      </h6>
      <div v-if="selectedLotId && ['Available'].includes(selectedLotStatus)" class="filter-wrapper">
        <div class="filter-text">
          {{ messages.filteredBy }}
          <span>Site {{ selectedLotId }}</span>
        </div>
        <span @click="closeLotInfo" class="icon icon-close-grey"></span>
      </div>
      -->
    </div>
</template>

<script setup lang="ts">
import {
  ref,
  computed,
  watch,
  onMounted,
  onBeforeUnmount,
  toRefs,
  inject,
} from 'vue';
import AppHeaderBreadcrumb from './AppHeaderBreadCrumb.vue';
import NeighborhoodList from './AppHeaderNeighborhoodList.vue';
import AppHeaderCommunityDetails from './AppHeaderCommunityDetails.vue';
import ArrowDownIcon from '@/assets/icons/ArrowDown.vue';
import { HomePlanSortOptions, QmiDaysFilter, Settings } from '@/constant';
import { isMobile, isTablet } from 'mobile-device-detect';
import LotSummary from './LotSummary.vue';

import type {
  CommunityQmiDetails,
  HeaderData,
  Lot,
  NeighboorhoodCoords,
  NeighborhoodInfo,
  NeighborhoodPlanQmiCounts,
  NeighborhoodPlatMap,
  NeighborhoodSoldDetails,
  QmiDays,
  Sibling,
  SidebarHomePlan,
  planDetails,
} from '../types';
import emitter from '@/mitt';

const props = defineProps<{
  coordinates?: NeighborhoodPlatMap[];
  qmiDetails: CommunityQmiDetails;
  headerData: HeaderData;
  availableSites: number;
  availablePlans: number;
  isKioskMode: boolean;
  messages: any;
  selectedLotId: string;
  selectedLotStatus: string;
  neighborhoods: NeighborhoodInfo[];
  selectedNeighborhoodIds: string[];
  planPriceExsist: boolean;
  selectedSorting: string;
  qmiAndHomeplans: any[];
  availableLots: number;
  soldPercentage: NeighborhoodSoldDetails[];
  neighborhoodsPlanQmiCount: NeighborhoodPlanQmiCounts[];
  communityHomePlans: SidebarHomePlan[];
  initialHomePlanCount: number;
  filterQmiCount: number;
  qmiAppliedMobile: boolean;
  sidebarOpen: boolean;
  homeTypeCount: number;
  totalMobileFilterApplied: number;
  showSelectedLotInformation: boolean;
  lotInformationData: Lot;
  communityName: string;
  areaName: string;
  homeplans?: any[];
  updateQmiData: (list: any[]) => any[];
  showQmiPlans: (filter: boolean) => any[];
}>();

const {
  coordinates,
  qmiDetails,
  headerData,
  availableSites,
  availablePlans,
  isKioskMode,
  messages,
  selectedLotId,
  selectedLotStatus,
  neighborhoods,
  selectedNeighborhoodIds,
  planPriceExsist,
  selectedSorting,
  qmiAndHomeplans,
  availableLots,
  soldPercentage,
  neighborhoodsPlanQmiCount,
  communityHomePlans,
  initialHomePlanCount,
  filterQmiCount,
  qmiAppliedMobile,
  sidebarOpen,
  homeTypeCount,
  totalMobileFilterApplied,
  areaName,
  communityName,
  showSelectedLotInformation,
  lotInformationData,
} = toRefs(props);

const emit = defineEmits([
  'filterPlanNameHomeType',
  'updateQmiFilterData',
  'setSorting',
  'setPlanNameListId',
  'loadNeighborhood',
  'applyMobileFilters',
  'setPlanDetailsHometypeList',
  'applyMobilePriceFilter',
  'sethoverNeighborZoomLevel',
  'selectNeighborhood',
  'hideSibling',
  'highlightNeighborhood',
  'clearSelectedNeighborhoods',
  'closeLotInfo',
  'toggleshowFilters',
  'showQmiHomeplans',
  'clearQmiDaysFilter',
]);
const isSalesOrLandView = inject('setSelectionDropdown', ref(false));

const qmiFilter = ref(false);
const qmiFilterList = ref<QmiDays[]>([]);
const initialQmiFilterList = ref<QmiDays[]>([]);
const hideSortQmiOption = ref(false);
const isAnyFilterApplied = ref(false);

const sortDropdown = ref(false);
const qmiDaysFilterDropdown = ref(false);
const homePlanSortOptions = HomePlanSortOptions;
const qmiDaysFilter = QmiDaysFilter;
const hasMobile = !!(isMobile && !isTablet);

const platmapCommunityDetails = ref<InstanceType<
  typeof AppHeaderCommunityDetails
> | null>(null);

const sethoverNeighborZoomLevel = (payload: {
  zoomLevel: number;
  isDisableHoverNeighbor: boolean;
  centerMap: NeighboorhoodCoords;
}) => {
  emit('sethoverNeighborZoomLevel', payload);
};
const loadNeighborhood = (payload: {
  areaName: string;
  communityName: string;
  neighborhoodName: string;
}) => {
  emit('loadNeighborhood', payload);
};
const hideSibling = () => {
  emit('hideSibling');
};
const highlightNeighborhood = (payload: {
  neighborhoodId: string;
  display: string;
}) => {
  emit('highlightNeighborhood', payload);
};
const selectNeighborhood = (neighborhodId: string) => {
  emit('selectNeighborhood', neighborhodId);
};
const closeLotInfo = () => {
  emit('closeLotInfo');
};
const setSorting = (option: any) => {
  emit('setSorting', option);
};
const filterPlanNameHomeType = (payload: {
  listHomeType: string[];
  listPlanName: string[];
  maxPrice: number;
  minPrice: number;
}) => {
  const { listHomeType, listPlanName, maxPrice, minPrice } = payload;
  isAnyFilterApplied.value =
    !!listHomeType.length ||
    !!listPlanName.length ||
    maxPrice !== Settings.MaxValue ||
    minPrice !== Settings.MinValue;
  emit('filterPlanNameHomeType', payload);
};
const applyMobilePriceFilter = (payload: {
  minValue: number;
  maxValue: number;
}) => {
  emit('applyMobilePriceFilter', payload);
};
const applyMobileFilters = (payload: {
  listPlanName: string[];
  listHomeType: string[];
  list: QmiDays[];
}) => {
  emit('applyMobileFilters', payload);
};
const toggleshowFilters = () => {
  emit('toggleshowFilters');
};
const setPlanNameListId = (listPlanNameId: string[]) => {
  emit('setPlanNameListId', listPlanNameId);
};
const clearSelectedNeighborhoods = () => {
  platmapCommunityDetails.value?.clearAllFilters?.();
  emit('clearSelectedNeighborhoods');
};
const showQmiHomeplans = (q: boolean) => {
  emit('showQmiHomeplans', q);
};
const clearQmiDaysFilter = (isQmiSelected: boolean) => {
  emit('clearQmiDaysFilter', isQmiSelected);
};
const setPlanDetailsHometypeList = (payload: {
  communityHomePlans: SidebarHomePlan[];
  homeTypeList: Set<string>;
  minPrice: number;
  maxPrice: number;
}) => {
  emit('setPlanDetailsHometypeList', payload);
};

const toggleDropdownVisibility = () => {
  if (!disableSortQmiFilter.value) sortDropdown.value = !sortDropdown.value;
};

const closeQmiFilter = () => {
  qmiDaysFilterDropdown.value = !qmiDaysFilterDropdown.value;
  qmiFilterList.value = [...initialQmiFilterList.value];
};

const qmiFilterUpdate = () => {
  if (!qmiFilter.value) {
    qmiFilterList.value = [];
  }
};

const hideDropDown = (e: Event) => {
  const dropdown = document.querySelector('.sort-price-container');
  const qmiFilterdropdown = document.querySelector('.qmi-filter');
  if (dropdown && !dropdown.contains(e.target as Node)) {
    sortDropdown.value = false;
  }
  if (qmiFilterdropdown && !qmiFilterdropdown.contains(e.target as Node)) {
    qmiFilterList.value = [...initialQmiFilterList.value];
    qmiDaysFilterDropdown.value = false;
  }
};

const applyMoveInDaysFilter = () => {
  if (qmiFilterList.value.length) {
    qmiFilter.value = true;
    qmiDaysFilterDropdown.value = false;
    initialQmiFilterList.value = [...qmiFilterList.value];
    let qmiArray: any[] = props.updateQmiData(qmiFilterList.value);
    emit('updateQmiFilterData', qmiArray);
  }
};

const checkSubFilters = () => {
  hideSortQmiOption.value = false;
  if (selectedNeighborhoodIds.value.length) {
    const currentNeighborhoodData = soldPercentage.value.find(
      (neighborhood) =>
        neighborhood.neighborhoodId === selectedNeighborhoodIds.value[0]
    );
    if (currentNeighborhoodData) {
      hideSortQmiOption.value = !!(
        currentNeighborhoodData.totalLotsCount === 0 ||
        initialHomePlanCount.value === 0
      );
    } else {
      hideSortQmiOption.value = true;
    }
  } else {
    if (soldPercentage.value.length !== neighborhoods.value.length) {
      hideSortQmiOption.value = true;
    } else {
      const lotsHomePlans = soldPercentage.value.find(
        (neighborhood) =>
          neighborhood.totalLotsCount && initialHomePlanCount.value
      );
      hideSortQmiOption.value = !lotsHomePlans;
    }
  }
};

const clearMoveInDaysFilter = () => {
  qmiFilterList.value = [];
  initialQmiFilterList.value = [];
  qmiFilter.value = false;
  clearQmiDaysFilter(qmiFilter.value);
};

const applyUrlQmi = (list: QmiDays[]) => {
  qmiFilterList.value = list;
  applyMoveInDaysFilter();
};

const changeQmifilterSelectedNeighborhoodIds = computed(
  () => `${qmiFilter.value} ${selectedNeighborhoodIds.value}`
);

const disableSortQmiFilter = computed(() => {
  if (!selectedNeighborhoodIds.value.length) {
    const totalLots = soldPercentage.value.filter(
      (each) => !each.totalLotsCount
    );
    return (
      !initialHomePlanCount.value ||
      totalLots.length === soldPercentage.value.length
    );
  } else {
    const currentNeighborhoodTotalCount = soldPercentage.value.filter(
      (each) => each.neighborhoodId === selectedNeighborhoodIds.value[0]
    );
    return (
      !initialHomePlanCount.value ||
      !currentNeighborhoodTotalCount[0]?.totalLotsCount
    );
  }
});
const neighborhoodLotsCount = (neighborhoodId: string) => {
  return (
    soldPercentage.value.find((p) => p.neighborhoodId === neighborhoodId)
      ?.totalLotsCount || 0
  );
};

const isComingSoon = (sibling: Sibling) =>
  sibling.nb_unit_status?.toLowerCase().includes('coming soon');

watch(changeQmifilterSelectedNeighborhoodIds, () => {
  if (!qmiFilterList.value.length) {
    let qmiArray: any[] = props.showQmiPlans(qmiFilter.value);
    emit('updateQmiFilterData', qmiArray);
  }
  if (qmiFilter.value && !qmiFilterList.value.length) {
    qmiFilterList.value = [...qmiDaysFilter];
    initialQmiFilterList.value = [...qmiDaysFilter];
    applyMoveInDaysFilter();
  } else if (!qmiFilter.value) {
    qmiFilterList.value = [];
    initialQmiFilterList.value = [];
    let qmiArray: any[] = props.showQmiPlans(false);
    emit('updateQmiFilterData', qmiArray);
  } else {
    applyMoveInDaysFilter();
  }
});

watch(soldPercentage, () => {
  checkSoldFilters();
});

const checkSoldFilters = () => {
  checkSubFilters();
};

watch(selectedNeighborhoodIds, () => {
  checkFilters();
});

const checkFilters = () => {
  checkSubFilters();
};

watch(sidebarOpen, () => {
  if (hasMobile) {
    const el = document.getElementsByClassName('new-panarea')[0] as
      | HTMLElement
      | undefined;
    if (el) {
      el.addEventListener('touchstart', () => {
        toggleshowFilters();
      });
    }
  }
});

const resetSelectedSorting = () => {
  clearMoveInDaysFilter();
  if(homePlanSortOptions.length) {
    setSorting(homePlanSortOptions[0])
  }
};

onMounted(() => {
  emitter.on('communityUpdated', resetSelectedSorting);
  emitter.on('newDivisonSelected', resetSelectedSorting);
  checkSubFilters();
  if (hasMobile) {
    const el = document.getElementsByClassName('new-panarea')[0] as
      | HTMLElement
      | undefined;
    if (el) {
      el.addEventListener('touchstart', () => {
        toggleshowFilters();
      });
    }
  }
  window.addEventListener('click', hideDropDown);
});

onBeforeUnmount(() => {
  window.removeEventListener('click', hideDropDown);
});
</script>

<style lang="scss">
.new-panarea {
  @include md {
    position: sticky;
    top: 0;
    background-color: #353535;
    z-index: 4;
  }
}
.pan-area {
  padding-bottom: 15px;
  display: block;
  position: absolute;
  top: 10px;
  left: 50%;
  translate: -50%;

  @include md {
    display: none;
  }

  &:before {
    content: '';
    width: 64px;
    height: 4px;
    background: #d9d9d9;
    display: block;
    border-radius: 50px;
    margin-inline: auto;
  }
}

.sidebar-topcontent {
  padding-inline: 8px;

  .breadcrumb {
    margin-bottom: 8px;
  }
}

.sidebar-wrapper {
  height: 100%;
}

.sort-price {
  &-container {
    @extend %flex-center;
    color: $white;
    @include font(12px, 600);
    column-gap: 8px;
    --dropdownPaddingX: 6px;
  }

  &-btngroups {
    display: flex;
    flex-wrap: wrap;
    column-gap: 7px;

    > div {
      flex: 1;
      white-space: nowrap;
    }
  }

  &-btn {
    @extend %flex-center;
    column-gap: 6px;
    appearance: none;
    background: transparent;
    outline: none;
    box-shadow: none;
    border: 0;
    color: $white;
    cursor: pointer;
    @include font(12px, 600);
  }
}

.hide {
  display: none;
}

.qmi-filter {
  display: none;

  @include md {
    display: flex;
  }

  .dropdown {
    width: 150px;
    --flexGap: 8px;
  }
}

.disableApplyButton {
  cursor: auto;
  opacity: 0.6;
}

.disableSort {
  opacity: 0.5;
  pointer-events: none;
}
</style>
